// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8299f58","239":"2bd8e8d9","667":"cdf0ceaa"}[chunkId] + ".chunk.js";
};